__turbopack_context__.v({
  "arrowIcon": "Dropdown-module-scss-module__a0p15q__arrowIcon",
  "container": "Dropdown-module-scss-module__a0p15q__container",
  "count": "Dropdown-module-scss-module__a0p15q__count",
  "error": "Dropdown-module-scss-module__a0p15q__error",
  "label": "Dropdown-module-scss-module__a0p15q__label",
  "noResults": "Dropdown-module-scss-module__a0p15q__noResults",
  "optionItem": "Dropdown-module-scss-module__a0p15q__optionItem",
  "optionItemCount": "Dropdown-module-scss-module__a0p15q__optionItemCount",
  "options": "Dropdown-module-scss-module__a0p15q__options",
  "root": "Dropdown-module-scss-module__a0p15q__root",
  "select": "Dropdown-module-scss-module__a0p15q__select",
  "selectContent": "Dropdown-module-scss-module__a0p15q__selectContent",
  "selected": "Dropdown-module-scss-module__a0p15q__selected",
  "value": "Dropdown-module-scss-module__a0p15q__value",
});
